import React from 'react'
import { Link } from "react-router-dom"
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import FeaturedPost from './blog/FeaturedPost.js'
import posts from './blog/posts/posts.js'
import links from './nav'

function Home () {
  return (
    <div className="App">
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Paper
            sx={{
              position: 'relative',
              backgroundColor: 'grey.800',
              color: '#fff',
              mb: 4,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundImage: `url(/banner.png)`,
            }}
          >
            {/* Increase the priority of the hero background image */}
            {<img style={{ display: 'none' }} src='/banner.png' alt="banner" />}
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
                backgroundColor: 'rgba(0,0,0,.3)',
              }}
            />
            <Grid container>
              <Grid item md={12}>
                <Box
                  sx={{
                    position: 'relative',
                    p: { xs: 3, md: 6 },
                    pr: { md: 0 },
                  }}
                >
                  <Typography variant="h3" component="h1" style={{ fontSize: 84, color: '#fff', fontWeight: 'bold', textShadow: '2px 2px 2px #000000' }} gutterBottom>
                    Blackburn Defense
                  </Typography>
                  <Typography variant="h5" color="inherit" style={{ color: '#fff', textShadow: '2px 2px 2px #000000' }}paragraph>
                    Accuracy speaks for itself.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={2} />
        <Grid item xs={8} style={{ textAlign: 'center' }}>
          <Typography variant="h3" mb={1}>
            <b>Our Mission</b> 
          </Typography>
          <Divider />
          <Typography variant="h6" style={{ textAlign: "justify" }} my={2}>
            To answer the question, "Why doesn't every bullet go through the same hole?"
            Leveraging advanced technology and expert knowledge, we explore the factors influencing bullet trajectory and impact.
            Our work not only pushes the boundaries of firearms accuracy but also offers vital insights for marksmen and enthusiasts.
            Join us in redefining precision in shooting.
          </Typography>
          <Divider />
        </Grid>
        <Grid item xs={2} />
        <Grid item xs={12} mt={4}>
          <Typography variant="h1" component="h2">
            Featured Tools
          </Typography>
          <Divider />
        </Grid>
        {links.filter(link => link.featured).map((link, index) => (
          <Grid item xs={6} sm={4} md={2} key={index}>
            <Link to={link.url} key={index} className="link" style={{ textDecoration: 'none' }}>
              <Card style={{ height: 200 }}>
                <CardContent>
                  <link.icon style={{ fontSize: 100, color: link.color }} />
                  <Typography variant="h5" component="div">
                    {link.label}
                  </Typography>
                </CardContent>
              </Card>
            </Link>
          </Grid>
        ))}
        <Grid item xs={6} sm={4} md={2}>
          <Link to="/tools" className="link" style={{ textDecoration: 'none' }}>
            <Card style={{ height: 200 }}>
              <CardContent>
                <ArrowForwardIcon style={{ fontSize: 100, color: '#000000' }} />
                <Typography variant="h5" component="div">
                  View All...
                </Typography>
              </CardContent>
            </Card>
          </Link>
        </Grid>
        <Grid item xs={12} mt={4}>
          <Typography variant="h1" component="h2">
            Recent Blog Posts
          </Typography>
          <Divider />
        </Grid>
        {posts.map(post => <FeaturedPost post={post} />)}
      </Grid>
    </div>
  );
}

export default Home
